module.exports = __webpack_public_path__ + "static/media/edit.136dd789.svg";